import './App.css';
import NetworkGraph from './components/NetworkGraph';

function App() {
  return (
      <NetworkGraph/>
  );
}

export default App;

